<template>
  <div data-locator="move-content">
    <v-row no-gutters>
      <div class="text-subtitle-1 text-text-primary">
        <b>{{ $t('project.documents.pane.DocumentsPaneMove.moveTo') }}</b>
      </div>
    </v-row>
    <v-row no-gutters class="mt-4">
      <AppClosdFildersTree
        v-model:value="selectedFolder"
        :root-folder="documentsTree"
        folders-only
        style="width: 100%;"
        :multiple="false"
        :default-expand="false"
      />
      <AppClosdFildersTree
        v-if="todoDocumentsTree"
        v-model:value="selectedFolder"
        :root-folder="todoDocumentsTree"
        folders-only
        style="width: 100%;"
        :multiple="false"
        :default-expand="false"
      />
    </v-row>
    <v-row>
      <v-col>
        <div class="d-flex justify-end ga-4">
          <app-button
            type="outlined"
            variant="neutral"
            data-locator="cancel-button"
            @click="close"
          >
            {{$t('common.cancel')}}
          </app-button>
          <app-button
            :disabled="isMoveDisabled"
            :loading="moveLoading"
            data-locator="confirm-button"
            @click="move"
          >
            {{ $t('project.documents.pane.DocumentsPaneMove.move') }}
          </app-button>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import { reactive } from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'

import AppClosdFildersTree from '@/common/app-closd-filders-tree/AppClosdFildersTree.vue'
import { toast } from '@/common/utils/toast'
import { CLOSE_TABLE_DOCUMENTS_PANE, LOAD_FOLDERS_TREE, MOVE_FILDERS } from '@/store/modules/documents/action_types'
import { SET_DOCUMENTS_TO_MOVE, SET_MOVEMENT_SNACKBAR_IS_OPEN } from '@/store/modules/documents/mutation_types'

export default {
  name: 'DocumentsPaneMove',
  components: { AppClosdFildersTree },
  data () {
    return {
      selectedFolder: [],
    }
  },
  computed: {
    ...mapState('documents', ['documents', 'moveLoading', 'documentsTablePane', 'foldersTree']),
    isMoveDisabled () {
      return this.documentsTablePane.documents.length === 0 || !this.isSelectedFolderValid
    },
    isSelectedFolderToDoChild () {
      return this.todoDocumentsTree?.children?.some(doc => doc.id === this.selectedFolder[0].id) || false
    },
    isSelectedFolderValid () {
      return this.selectedFolder.length !== 0 &&
          this.selectedFolder[0]?.specialFolder !== 'todo' &&
          this.selectedFolder[0]?.specialFolder !== 'qa' &&
          (this.documentsTablePane.documents.every(doc => doc.type !== 'folder') || !this.isSelectedFolderToDoChild)
    },
    documentsTree () {
      const qaFolderId = this.foldersTree.qaFolderId

      return {
        id: 0,
        type: 'folder',
        name: this.$t('common.documents.rootFolder'),
        basename: this.$t('common.documents.rootFolder'),
        children: this.foldersTree.folders
          .filter(folder => folder.id !== qaFolderId)
          .map(folder => ({
            ...folder,
            basename: folder.name,
            childrenCount: folder.hasFolderChildren ? 1 : 0,
            type: 'folder',
          })),
      }
    },
    todoDocumentsTree () {
      if (this.foldersTree.todoFolderId === null || !this.foldersTree.hasAccessToTodoFolder) {
        return false
      }

      // Here using "reactive" is necessary because the AppClosdFildersTree component applies changes to the "children"
      // field of its "rootFolder" prop, and some computed properties depend on it (It's a bad practice but we prefer
      // to not change a common component so we make a change here)
      return reactive({
        id: this.foldersTree.todoFolderId,
        type: 'folder',
        name: this.$t('common.documents.todoFolder'),
        basename: this.$t('common.documents.todoFolder'),
        children: [],
        childrenCount: 1,
        specialFolder: 'todo',
      })
    },
  },
  methods: {
    ...mapActions('documents', [CLOSE_TABLE_DOCUMENTS_PANE, LOAD_FOLDERS_TREE, MOVE_FILDERS]),
    ...mapMutations('documents', [SET_DOCUMENTS_TO_MOVE, SET_MOVEMENT_SNACKBAR_IS_OPEN]),
    async move () {
      this.SET_MOVEMENT_SNACKBAR_IS_OPEN(false)
      this.SET_DOCUMENTS_TO_MOVE({
          documents: this.documentsTablePane.documents,
          originalFolderId: this.documentsTablePane.documents[0]?.parentId || 0,
        })
      try {
        await this.MOVE_FILDERS({
          documents: this.documentsTablePane.documents,
          targetFolderId: this.selectedFolder[0].id,
        })
        this.SET_MOVEMENT_SNACKBAR_IS_OPEN(true)
        this.close()
        await this.LOAD_FOLDERS_TREE()
      } catch {
        toast.error(this.$t('project.documents.pane.DocumentsPaneMove.errorMessage'))
      }
    },
    close () {
      this.CLOSE_TABLE_DOCUMENTS_PANE()
      this.selectedFolder = []
    },
  },
}
</script>
